import * as React from "react";

import {ITopicWidgetAnswer} from "src/app/nlp/~store/models/TopicWidgetAnswer";
import {IAnswerMessageBodyProps} from "./~types/AnswerMessageBodyProps";
import {buildUrlWithUserSegment} from "src/app/shared/helpers/user-auth-helper/UserAuthHelper";

import AnswerHolder from "./answer-holder/AnswerHolder";

import './AnswerMessageBody.css';
import i18n from "src/app/shared/localization/i18n";

export default class AnswerMessageBody extends React.Component<IAnswerMessageBodyProps> {
    public render() {
        const answers = this.props.answerMessage.answers.sort((a1, a2) => a2.confidence - a1.confidence);
        return answers && answers.length
        ? this._mapAnswerMessagesToTable(answers, this.props.answerMessage.questionText, this.props.answerMessage.usedML)
        : this._getNotFoundAnswerMessage(this.props.answerMessage.questionText);
    }

    private _mapAnswerMessagesToTable(answers: ITopicWidgetAnswer[], questionText: string, usedML: boolean): React.ReactElement<{}> {
        return (
            <div className="answers-holder">
                {usedML && <div className="answers-holder-ml-container"><p>✨ {i18n.t("nlp.foundViaML")}</p></div>}
                <div className="question-text-from-server">{i18n.t('nlp.actualSearchString')} <span>{questionText}</span></div>
                {answers.map((answer, index) => this._mapAnswerToTableRow(answer, index))}
            </div>
        );
    }

    private _mapAnswerToTableRow(answer: ITopicWidgetAnswer, index: number): React.ReactElement<{}> {
        return (
            <AnswerHolder key={index} answer={answer} />
        );
    }

    private _getNotFoundAnswerMessage = (questionText: string): React.ReactElement<{}> => {
        return (<div className="answers-holder">
                    <div className="question-text-from-server">{i18n.t('nlp.actualSearchString')} <span>{questionText}</span></div>
                    <div>{i18n.t('nlp.answerNotFound')}</div>
                </div> );
    };
}
